export const encodeIdToBase36 = (number) => {
  if (!Number.isInteger(number) || number < 0) {
    return
  }
  return number.toString(36).toUpperCase()
}
